import { TransformInt } from '../../../shared/decorators/transform-int.decorator';

import { CreateVehicleDamageDto } from './create-vehicle-damage.dto';

/**
 * Update vehicle damage DTO
 */
export class UpdateVehicleDamageDto extends CreateVehicleDamageDto {
	@TransformInt()
	id!: number;
}
